// @ts-nocheck
import List from '@material-ui/core/List';
import { Domain } from '@material-ui/icons';
import AtlasIcon from '@material-ui/icons/Airplay';
import SettingsIcon from '@material-ui/icons/BrightnessLow';
import HyperGateIcon from '@material-ui/icons/Cast';
import CardIcon from '@material-ui/icons/CreditCard';
import RegistryIcon from '@material-ui/icons/HdrWeak';
import InvitationsIcon from '@material-ui/icons/InsertLink';
import LockIcon from '@material-ui/icons/LockOpen';
import RolesIcon from '@material-ui/icons/Security';
import AnalyticsIcon from '@material-ui/icons/ShowChart';
import GatewayIcon from '@material-ui/icons/WifiTethering';
import TabletIcon from '@material-ui/icons/Tablet';
import { withStyles } from '@material-ui/styles';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import { LICENSE_TYPES, PERMISSIONS, PERMISSION_ENTITIES, SUBSCRIPTION_TYPES } from '../_config/consts';
import { getPlantName } from '../_config/utils';
import AccessProfilesIconCustom from '../components/CustomIcons/AccessProfilesIconCustom.jsx';
import AdminEventsIconCustom from '../components/CustomIcons/AdminEventsIconCustom.jsx';
import AgendaIconCustom from '../components/CustomIcons/AgendaIconCustom.jsx';
import CameraIconCustom from '../components/CustomIcons/CameraIconCustom.jsx';
import CommunicationIconCustom from '../components/CustomIcons/CommunicationIconCustom.jsx';
import DashboardIconCustom from '../components/CustomIcons/DashboardIconCustom.jsx';
import EventIconCustom from '../components/CustomIcons/EventIconCustom.jsx';
import InstallerOutlinedIconCustom from '../components/CustomIcons/InstallerOutlinedIconCustom.jsx';
import KeyOutlinedIconCustom from '../components/CustomIcons/KeyOutlinedIconCustom.jsx';
import MapIconCustom from '../components/CustomIcons/MapIconCustom.jsx';
import MessageAlertIconCustom from '../components/CustomIcons/MessageAlertIconCustom.jsx';
import AreasManagementIconCustom from '../components/CustomIcons/AreasManagementIconCustom.jsx';
import PinIconCustom from '../components/CustomIcons/PinIconCustom.jsx';
import PlatformUserIconCustom from '../components/CustomIcons/PlatformUserIconCustom.jsx';
import SmartLocksEventsIconCustom from '../components/CustomIcons/SmartLocksEventsIconCustom.jsx';
import SmartPhoneKeyIconCustom from '../components/CustomIcons/SmartPhoneKeyIconCustom.jsx';
import StoreOutlinedIconCustom from '../components/CustomIcons/StoreOutlinedIconCustom.jsx';
import SubcompanyEventIconCustom from '../components/CustomIcons/SubcompanyEventIconCustom.jsx';
import TagIconCustom from '../components/CustomIcons/TagIconCustom.jsx';
import UsersIconCustom from '../components/CustomIcons/UsersIconCustom.jsx';
import VisitorsIconCustom from '../components/CustomIcons/VisitorsIconCustom.jsx';
import CopyIconCustom from '../components/CustomIcons/CopyIconCustom.jsx';
import Permission from '../components/Permission/Permission.jsx';
import AbilityProvider from '../permissionsUtils/AbilityProvider.js';
import * as UserActions from '../redux/actions/user.actions';
import * as UtilsActions from '../redux/actions/utils.actions';
import ListBoxIconCustom from '../components/CustomIcons/ListBoxIconCustom.jsx';
import {
  CollapsibleMenu,
  MenuItem,
  MenuItemRenderer,
  SidebarFavoritesSection,
  SidebarNavContext,
  SidebarSearchField,
  SidebarSection,
  SidebarThemeRoot,
  sidebarStyles as styles,
} from './AppSidebarShared.jsx';
import {
  getSidebarFavorites,
  toggleSidebarFavorite,
} from './sidebarFavorites.js';

@withRouter
@connect(state => ({
  userToken: state.user.token,
  routing: state.router,
  userLicense: state.user.license,
  user: state.user,
  themeData: state.settings.items.theme.data,
  themeName: state.settings.items.theme.data.themeName,
  subcompanies: state.settings.subcompanies,
}))
class AppSidebarLimited extends React.Component {

  constructor(props) {
    super(props);
    this.menuIconRegistry = {};
    this.state = {
      isGatewayDropdownOpened: false,
      isEventsDropdownOpened: false,
      marketplaceCollapseOpen: false,
      sidebarSearchQuery: '',
      sidebarFavorites: [],
    };
    this.onSidebarSearchChange = this.onSidebarSearchChange.bind(this);
    this.onToggleSidebarFavorite = this.onToggleSidebarFavorite.bind(this);
    this.registerMenuIcon = this.registerMenuIcon.bind(this);
    this.getFavoriteIcon = this.getFavoriteIcon.bind(this);
    this.syncSidebarFavorites = this.syncSidebarFavorites.bind(this);
  }

  componentDidMount() {
    this.syncSidebarFavorites();
  }

  componentWillReceiveProps(nextProps) {
    const userId = this.props.user && this.props.user.data && this.props.user.data.id;
    const nextUserId = nextProps.user && nextProps.user.data && nextProps.user.data.id;
    if (userId !== nextUserId) {
      this.syncSidebarFavorites(nextProps);
    }
  }

  syncSidebarFavorites(props = this.props) {
    const userId = props.user && props.user.data && props.user.data.id;
    this.setState({ sidebarFavorites: getSidebarFavorites(userId) });
  }

  onSidebarSearchChange(value) {
    this.setState({ sidebarSearchQuery: value });
  }

  onToggleSidebarFavorite(favoriteEntry) {
    const userId = this.props.user && this.props.user.data && this.props.user.data.id;
    const nextFavorites = toggleSidebarFavorite(
      userId,
      this.state.sidebarFavorites,
      favoriteEntry,
    );
    this.setState({ sidebarFavorites: nextFavorites });
  }

  registerMenuIcon(menuId, icon) {
    if (!menuId) {
      return;
    }
    this.menuIconRegistry[menuId] = icon;
  }

  getFavoriteIcon(menuId) {
    return this.menuIconRegistry[menuId] || null;
  }
  
  render() {
    const { dispatch, themeData, userLicense, subcompanies, location, user, classes } = this.props;
    const companyLogo = themeData && themeData.logo;
    const licenseType = userLicense && userLicense.domainProductType;
    const canReadGuest = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.USER);
    const canReadLocks = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.SMART_LOCK);
    const canReadGateways = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.GATEWAY);
    const canReadAccesRules = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.CREDENTIAL_RULE);
    const canReadCards = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.STANDARD_DEVICE);
    const canReadLogs = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.LOG);
    const canEditGuestsTags = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.USER_TAG);
    const canEditLocksTags = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.SMART_LOCK_TAG);
    const isLuckeyEngine = AbilityProvider.getAbilityHelper().hasLicenseType(LICENSE_TYPES.ENGINE);
    const hideCredentialsRulesMenu = isLuckeyEngine || !canReadAccesRules && !canReadCards;
    const isBookeyActive = dispatch(UserActions.userHasSubscriptions(SUBSCRIPTION_TYPES.BOOKEY));
    const isTicketingManagementActive = dispatch(UtilsActions.isTicketingManagementActive());
    const isCapacityManagementActive = dispatch(UtilsActions.isCapacityManagementActive());
    const isItemRegistryPluginActive = dispatch(UserActions.userHasSubscriptions(SUBSCRIPTION_TYPES.REGISTRY));
    const isCommunicationPluginActive = dispatch(UserActions.userHasSubscriptions(SUBSCRIPTION_TYPES.COMMUNICATIONS));
    const isF9000PluginActive = dispatch(UserActions.isF9000AddonActive());
    const isMarketPlaceEnabled = dispatch(UserActions.isMarketPlaceEnabled());
    const isFakeCloudCredits = dispatch(UserActions.isFakeCloudCredits());
    const isCameraSectionActive = dispatch(UtilsActions.isEagleEyeIntegrationActive());
    const hasSharedLocks = dispatch(UtilsActions.hasSharedLocks());
    const isAccessProfileAddonActive = dispatch(UtilsActions.isAccessProfileAddonActive());
    const isVisitorsManagementActive = dispatch(UtilsActions.isVisitorsManagementActive());


    const systemHasAtlas = user.systemHasAtlas;
    const { themeName } = this.props;
    const { sidebarSearchQuery, sidebarFavorites } = this.state;
    const sidebarNavContextValue = {
      searchQuery: sidebarSearchQuery,
      sidebarFavorites,
      onToggleFavorite: this.onToggleSidebarFavorite,
      registerMenuIcon: this.registerMenuIcon,
    };
    const navContent = (
        <List component="nav" className={classes.sidebar}>
            <SidebarSection sectionKey="plantManagement" headerEntity="plantManagement">
              <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.RFID]} do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.USER} abilityHelper={AbilityProvider.getAbilityHelper()}>
                <MenuItem
                  showFavoriteControl
                  path="/guests"
                  icon={<UsersIconCustom className={classes.icon} style={{ width: 24.5 }} />}
                  entityKey="guests"
                  title={<Entity entity="guests" />}
                  isSelected={location && location.pathname && location.pathname === '/guests'}
                  onClick={() => dispatch(push('/guests'))}
                />
              </Permission>
              <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.RFID]} do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.SMART_LOCK} abilityHelper={AbilityProvider.getAbilityHelper()}>
                <MenuItem
                  showFavoriteControl
                  path="/locks"
                  icon={<LockIcon className={classes.icon} />}
                  entityKey="locks"
                  title={<Entity entity="locks" />}
                  isSelected={location && location.pathname && location.pathname === '/locks'}
                  onClick={() => dispatch(push('/locks'))}
                />
              </Permission>
              <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.GATEWAY} withLicenses={[LICENSE_TYPES.LITE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                <MenuItem
                  showFavoriteControl
                  path="/gateways"
                  icon={<HyperGateIcon className={classes.icon} />}
                  containerStyle={{ marginBottom: 1 }}
                  entityKey="hyperGatesPro"
                  title={<Entity entity="hyperGatesPro" />}
                  isSelected={location && location.pathname && location.pathname === '/gateways'}
                  onClick={() => dispatch(push('/gateways'))}
                />
              </Permission>
              {systemHasAtlas ? (
                <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.GATEWAY} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.RFID]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                  <CollapsibleMenu
                    isOpen={this.state.isGatewayDropdownOpened}
                    headerIcon={<GatewayIcon className={classes.icon} />}
                    headerEntityKey="gateways"
                  headerTitle={<Entity entity="gateways" />}
                    onToggleOpen={isOpen => this.setState({ isGatewayDropdownOpened: isOpen })}
                  >
                    <MenuItem
                      showFavoriteControl
                      path="/gateways"
                      icon={<HyperGateIcon className={classes.icon} />}
                      iconStyle={{ fontSize: 22 }}
                      containerStyle={{ marginBottom: 1 }}
                      entityKey="hyperGatesPro"
                  title={<Entity entity="hyperGatesPro" />}
                      isSelected={location && location.pathname && location.pathname === '/gateways'}
                      onClick={() => dispatch(push('/gateways'))}
                    />
                    <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.GATEWAY} abilityHelper={AbilityProvider.getAbilityHelper()}>
                      <MenuItem
                        showFavoriteControl
                        path="/atlas"
                        icon={<AtlasIcon className={classes.icon} />}
                        entityKey="hyperGatesAtlas"
                  title={<Entity entity="hyperGatesAtlas" />}
                        isSelected={location && location.pathname && location.pathname === '/gatewaysAtlas'}
                        onClick={() => dispatch(push('/gatewaysAtlas'))}
                      />
                    </Permission>
                  </CollapsibleMenu>
                </Permission>
              ): (
                <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.GATEWAY} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.RFID]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                  <MenuItem
                    showFavoriteControl
                    path="/gateways"
                    icon={<HyperGateIcon className={classes.icon} />}
                    iconStyle={{ fontSize: 22 }}
                    containerStyle={{ marginBottom: 1 }}
                    title={systemHasAtlas ? <Entity entity="hyperGatesPro" /> : 'HyperGates'}
                    isSelected={location && location.pathname && location.pathname === '/gateways'}
                    onClick={() => dispatch(push('/gateways'))}
                  />
                </Permission>
              )}
              <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.GATEWAY} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                <MenuItem
                  showFavoriteControl
                  path="/hypertouchDevices"
                  icon={<TabletIcon className={classes.icon} />}
                  iconStyle={{ fontSize: 22 }}
                  containerStyle={{ marginBottom: 1 }}
                  entityKey="hypertouchDevices"
                  title={<Entity entity="hypertouchDevices" />}
                  isSelected={location && location.pathname && location.pathname === '/hypertouchDevices'}
                  onClick={() => dispatch(push('/hypertouchDevices'))}
                />
              </Permission>
              {(canEditGuestsTags || canEditLocksTags) ?
                <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.LITE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.RFID]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                  <MenuItem
                    showFavoriteControl
                    path="/tagsManagement"
                    icon={<TagIconCustom className={classes.icon} style={{ width: 27 }} />}
                    iconStyle={{ width: 30 }}
                    entityKey="tagsManagement"
                  title={<Entity entity="tagsManagement" />}
                    isSelected={location && location.pathname && location.pathname === '/tagsManagement'}
                    onClick={() => dispatch(push('/tagsManagement'))}
                  />
                </Permission>
              : null}
            </SidebarSection>
          {!hideCredentialsRulesMenu && (
            <SidebarSection sectionKey="credentialRules" headerEntity="credentialRules">
              <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.CREDENTIAL_RULE} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.LITE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                <MenuItem
                  showFavoriteControl
                  path="/credentials"
                  iconStyle={{ width: 24 }}
                  icon={<SmartPhoneKeyIconCustom className={classes.icon} />}
                  entityKey="smartphones"
                  title={<Entity entity="smartphones" />}
                  isSelected={location && location.pathname && location.pathname === '/credentials'}
                  onClick={() => dispatch(push('/credentials'))}
                />
              </Permission>
              <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.STANDARD_DEVICE} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.LITE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.RFID]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                <MenuItem
                  showFavoriteControl
                  path="/cards"
                  icon={<CardIcon className={classes.icon} />}
                  entityKey="cards"
                  title={<Entity entity="cards" />}
                  isSelected={location && location.pathname && location.pathname === '/cards'}
                  onClick={() => dispatch(push('/cards'))}
                />
              </Permission>
              <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.STANDARD_DEVICE} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.LITE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.RFID]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                <MenuItem
                  showFavoriteControl
                  path="/pins"
                  icon={<PinIconCustom className={classes.icon} />}
                  entityKey="pins"
                  title={<Entity entity="pins" />}
                  isSelected={location && location.pathname && location.pathname === '/pins'}
                  onClick={() => dispatch(push('/pins'))}
                />
              </Permission>
            </SidebarSection>
          )}
          {canReadLogs && (
            <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.LITE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.RFID]} do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.USER} abilityHelper={AbilityProvider.getAbilityHelper()}>
              <div>
                <h5 className="sidebar-header-custom">
                  <Entity entity="manageEvents" />
                </h5>
                <hr className="sidebar-separator" />
                <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.LOG} abilityHelper={AbilityProvider.getAbilityHelper()}>
                  <MenuItem
                    showFavoriteControl
                    path="/adminEvents"
                    icon={<AdminEventsIconCustom className={classes.icon} />}
                    iconStyle={{ width: 24 }}
                    entityKey="adminEvents"
                  title={<Entity entity="adminEvents" />}
                    isSelected={location && location.pathname && location.pathname === '/adminEvents'}
                    onClick={() => dispatch(push('/adminEvents'))}
                  />
                </Permission>
                {hasSharedLocks ? (
                  <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.SMART_LOCK} abilityHelper={AbilityProvider.getAbilityHelper()}>
                    <CollapsibleMenu
                      isOpen={this.state.isEventsDropdownOpened}
                      headerIcon={<SmartLocksEventsIconCustom className={classes.icon} />}
                      headerEntityKey="doorEvents"
                  headerTitle={<Entity entity="doorEvents" />}
                      onToggleOpen={isOpen => this.setState({ isEventsDropdownOpened: isOpen })}
                    >
                      <MenuItem
                        showFavoriteControl
                        path="/smartLockEvents"
                        iconStyle={{ width: 25 }}
                        icon={(
                          <div style={{ position: 'relative' }}>
                            <Domain className={classes.icon} style={{ position: 'absolute', bottom: 2, fontSize: 15, right: -7 }} />   
                            <SubcompanyEventIconCustom className={classes.icon} />
                          </div>
                        )}
                        title={<Entity entity={getPlantName()} />}
                        isSelected={location && location.pathname && location.pathname === '/smartLockEvents'}
                        onClick={() => dispatch(push('/smartLockEvents'))}
                      />
                      {_.map(subcompanies, subcompany => (
                        <MenuItem
                          showFavoriteControl
                          path="/subcompaniesSmartLockEvents"
                          icon={(
                            <div style={{ position: 'relative' }}>
                              <Domain className={classes.icon} style={{ position: 'absolute', bottom: 2, fontSize: 15, right: -7 }} />   
                              <SubcompanyEventIconCustom className={classes.icon} />
                            </div>
                          )}
                          iconStyle={{ width: 24 }}
                          title={<Entity entity={subcompany.plantName} />}
                          isSelected={location && location.pathname && location.pathname === '/subcompaniesSmartLockEvents' && location.search === `?subcompanyId=${subcompany.id}`}
                          onClick={() => dispatch(push(`/subcompaniesSmartLockEvents?subcompanyId=${subcompany.id}`))}
                        />
                      ))}
                    </CollapsibleMenu>
                  </Permission>
                ) : (
                  <MenuItem
                    showFavoriteControl
                    path="/smartLockEvents"
                    iconStyle={{ width: 25 }}
                    icon={<SmartLocksEventsIconCustom className={classes.icon} />}
                    entityKey="doorEvents"
                  title={<Entity entity="doorEvents" />}
                    isSelected={location && location.pathname && location.pathname === '/smartLockEvents'}
                    onClick={() => dispatch(push('/smartLockEvents'))}
                  />
                )}
              </div>
            </Permission>
          )}
          <h5 className="sidebar-header-custom">
            <Entity entity="platformManagement" />
          </h5>
          <hr className="sidebar-separator" />
          <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.USER} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.LITE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.RFID]} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MenuItem
              showFavoriteControl
              path="/platformUsers"
              iconStyle={{ width: 25 }}
              icon={<PlatformUserIconCustom className={classes.icon} />}
              entityKey="platformUsers"
                  title={<Entity entity="platformUsers" />}
              isSelected={location && location.pathname && location.pathname === '/platformUsers'}
              onClick={() => dispatch(push('/platformUsers'))}
            />
          </Permission>
          <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.USER} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.LITE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.RFID]} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MenuItem
              showFavoriteControl
              path="/installers"
              iconStyle={{ width: 25 }}
              icon={<InstallerOutlinedIconCustom className={classes.icon} style={{ width: 24 }} />}
              entityKey="installers"
                  title={<Entity entity="installers" />}
              isSelected={location && location.pathname && location.pathname === '/installers'}
              onClick={() => dispatch(push('/installers'))}
            />
          </Permission>
          <MenuItem
            showFavoriteControl
            path="/settings"
            icon={<SettingsIcon className={classes.icon} />}
            entityKey="settings"
                  title={<Entity entity="settings" />}
            isSelected={location && location.pathname && (location.pathname === '/settings' || location.pathname === '/settings/octorate')}
            onClick={() => dispatch(push('/settings'))}
          />
          {licenseType !== LICENSE_TYPES.LITE && licenseType !== LICENSE_TYPES.RFID && companyLogo ? (
            <div style={{ paddingRight: 10, paddingBottom: 20, marginTop: 20, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              {companyLogo && <img src={companyLogo} alt="logo" style={{ width: 120, alignSelf: 'center' }} />}
            </div>
          ) : null}
        </List>
    );
    return (
      <SidebarThemeRoot themeName={themeName}>
        <SidebarNavContext.Provider value={sidebarNavContextValue}>
          <SidebarSearchField
            value={sidebarSearchQuery}
            onChange={this.onSidebarSearchChange}
          />
          <SidebarFavoritesSection
            favorites={sidebarFavorites}
            location={location}
            dispatch={dispatch}
            push={push}
            getFavoriteIcon={this.getFavoriteIcon}
            classes={classes}
          />
          {navContent}
        </SidebarNavContext.Provider>
      </SidebarThemeRoot>
    );
  }
}

export default withStyles(styles)(AppSidebarLimited);